<template>
  <div>
    <table
      v-if="tournaments.length"
      style="width: 100%; text-align: left"
      class="table mb-1"
    >
      <thead>
        <tr>
          <th style="width: 50%">Name</th>
          <th style="width: 10%">Type</th>
          <th style="width: 20%">Start Time</th>
          <th style="width: 20%; text-align: center">Players</th>
          <th style="width: 10%">Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-for="(tournament, i) in shownTournaments" :key="i">
        <tr :class="i % 2 === 0 ? 'even' : 'odd'" :style="rowStyle(tournament)">
          <td>
            <router-link
              :to="{
                name: 'OfflineClassTournament',
                params: { id: tournament.id },
              }"
              class="has-text-info"
            >
              {{ tournament.name }}
            </router-link>
          </td>
          <td>
            <p>{{ tournament | roundText }}</p>
            <p>
              {{ tournament | timeText }}
            </p>
          </td>
          <td>
            {{ tournament.startTime | asDate }}
            <br />
            {{ tournament.startTime | asDayjsFormat("hh:mm A (UTCZ)") }}
          </td>
          <td style="text-align: center">
            <p>
              <span>
                {{ tournament.playerCount ? tournament.playerCount : 0 }}
              </span>
              <span v-if="tournament.playerLimit">
                / {{ tournament.playerLimit }}
              </span>
            </p>
          </td>
          <td>
            {{ tournament | statusText }}
          </td>
          <td>
            <button
              class="button is-small is-fullwidth is-danger"
              @click="deleteTournament(tournament)"
            >
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="pageSize">
      <button
        v-if="shownTournaments.length < tournaments.length"
        class="button is-small is-ghost"
        @click="showMore"
      >
        {{ shownTournaments.length }} / {{ tournaments.length }}
        Show more ...
      </button>
      <button
        v-if="shownNumber > pageSize"
        class="button is-small is-ghost"
        @click="shownNumber = pageSize"
      >
        Show less
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfflineClassTournamentTable",
  components: {},

  props: ["tournaments", "pageSize"],

  data() {
    return {
      shownNumber: 5,
    };
  },

  computed: {
    shownTournaments() {
      if (!this.tournaments) return [];
      if (this.pageSize > 0) return this.tournaments.slice(0, this.shownNumber);
      return this.tournaments;
    },
  },

  filters: {
    statusText(tournament) {
      if (tournament.currentRound > tournament.totalRounds) return "Ended";
      if (tournament.currentRound === 0) return "Coming";
      return "Live";
    },

    roundText(tournament) {
      const currentRound = Math.min(
        tournament.currentRound,
        tournament.totalRounds
      );
      return `${currentRound}/${tournament.totalRounds} rounds - ${
        tournament.type === "Robin" ? "Round Robin" : tournament.type
      }`;
    },

    timeText(tournament) {
      return `${tournament.baseTimeControl}+${tournament.increment}`;
    },
  },

  methods: {
    rowStyle(tournament) {
      return {
        "background-color":
          tournament.currentRound === 0
            ? "paleturquoise"
            : tournament.currentRound > tournament.totalRounds
            ? "white"
            : "palegreen",
      };
    },

    showMore() {
      if (!this.pageSize) return;
      if (this.shownNumber < this.tournaments.length) {
        this.shownNumber += this.pageSize;
      }
    },

    deleteTournament(tournament) {
      this.$buefy.dialog.confirm({
        title: "Deleting Tournamnet",
        message: `Are you sure you want to <b>delete</b> tournament <b>${tournament.name}</b>? This action cannot be undone.`,
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$emit("onDelete", tournament);
        },
      });
    },
  },
};
</script>

<style scoped>
th {
  background-color: darkslateblue;
  color: whitesmoke !important;
}

td {
  vertical-align: middle !important;
}

p {
  white-space: nowrap;
  overflow: hidden;
}
</style>
